import { Navigate, Route, Routes } from 'react-router-dom';

import withPermission from 'hooks/withPermission';

import { PATH } from 'constants/path';

import { AdminLayout } from './components/AdminLayout';
import { AddAdminPage } from './page/AddAdminPage';
import AdminUserPage from './page/AdminUserPage';

const AdminUSerRoutes = () => {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<AdminUserPage />} />

        <Route path="*" element={<Navigate to={PATH.ERROR_404} />} />
      </Route>
      <Route path={PATH.ADD_ADMIN} element={<AddAdminPage />} />
      <Route path={PATH.EDIT_ADMIN} element={<AddAdminPage />} />
    </Routes>
  );
};

export default withPermission(['Admins'])(AdminUSerRoutes);
